import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { useMoralis } from "react-moralis";
import button_spinner from "../images/Rolling.gif";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moralis from "moralis";
import Web3 from "web3";

const Editprofile = () => {
  const [profileLoading, setProfileLoading] = useState(false);
  const { user } = useMoralis();
  Moralis.initialize("lGFqxutUnQZXqqxy5N1optlMEzpT6RJW7BwbcMmw");
  Moralis.serverURL = "https://kquqmy2unesf.usemoralis.com:2053/server";

  async function imgUpload() {
    const data = document.querySelector("input[type=file]").files[0];
    const file = new Moralis.File(data.name, data);
    await file.saveIPFS();
    //console.log(file.ipfs());
    return file.ipfs();
  }
  async function updateProfile() {
    setProfileLoading(true);
    const EntredProfileName = document.getElementById("profileName").value;
    const EntredTwitter = document.getElementById("twitter").value;
    const EntredInstagram = document.getElementById("instagram").value;
    const EntredBio = document.getElementById("profileBio").value;
    const EntredBgImageUrl = document.getElementById("pro_back_image").value;
    const proImageUrl = await imgUpload();
    console.log(proImageUrl);

    if (EntredProfileName) {
      const web3 = new Web3(window.ethereum);
      const accounts = await web3.eth.getAccounts();
      const Profiles = Moralis.Object.extend("Profiles");
      const accountAddress = accounts[0];
      const upperCaseAddress = accountAddress.toUpperCase();
      const userProfile = new Profiles();
      userProfile.set("name", EntredProfileName);
      userProfile.set("pro_image", proImageUrl);
      userProfile.set("userAddress", upperCaseAddress);
      userProfile.set("twitter", EntredTwitter);
      userProfile.set("instagram", EntredInstagram);
      userProfile.set("bgImage", EntredBgImageUrl);
      userProfile.set("bio", EntredBio);
      await userProfile.save();
      toast.success("Profile Updated", {
        autoClose: 2000,
        theme: "colored",
      });
      setTimeout(function () {
        window.location.reload(true);
      }, 6000);
    } else {
      document.getElementById("profileName-val").innerHTML = "Required Field";
    }

    setProfileLoading(false);
  }
  return (
    <div className="grand_parent_div">
      <ToastContainer />
      <div className="edit-profile-wrapper">
        <div>
          <div className="edit-profile-div">
            <div className="profile-inputs-div">
              {" "}
              <label>Name</label>
              <input type="text" id="profileName"></input>
              <label id="profileName-val"></label>
            </div>
            <div className="profile-inputs-div">
              {" "}
              <label>Bio</label>
              <input type="text" id="profileBio"></input>
              <label id="profileBio-val"></label>
            </div>
            <div className="profile-inputs-div">
              {" "}
              <label>Twitter (Full URL)</label>
              <input type="url" id="twitter" required></input>
              <label id="twitter-val"></label>
            </div>
            <div className="profile-inputs-div">
              {" "}
              <label>Instagram (Full URL)</label>
              <input type="url" id="instagram"></input>
              <label id="instagram-val"></label>
            </div>
            <div className="profile-inputs-div" id="profileImage">
              {" "}
              <label>Profile Image</label>
              <input type="file" id="pro_image"></input>
            </div>
            <div className="profile-inputs-div" id="profileImage">
              {" "}
              <label>Background Image URL</label>
              <input type="url" id="pro_back_image"></input>
            </div>

            <div className="profile-inputs-div">
              <button
                id="editProfileBtn"
                className="mint-btn"
                onClick={updateProfile}
              >
                {!profileLoading && "Update"}
                {profileLoading && (
                  <img src={button_spinner} width="40px" height="40px" />
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Editprofile;
